module.exports = __webpack_public_path__ + "static/img/5.064efb1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/1/zh/5.png
// module id = cBMA
// module chunks = 0